var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChatWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    strokeWidth: 1.2,
    stroke: "#FFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-406 -1308) translate(407 1309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C17.851 0 23 5.149 23 11.5S17.851 23 11.5 23c-2.196 0-4.249-.616-5.994-1.684l-.014.01c-1.947 1.325-5.514 1-5.492.905 1.395-.745 2.318-1.95 2.77-3.612l-.08.273C1.011 16.893 0 14.315 0 11.5 0 5.149 5.15 0 11.5 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 11.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 11.5,
    r: 0.6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatWhite);
export default __webpack_public_path__ + "static/media/icon-chat-white.6b81f7d3bd9a80433df4b928adeb01c2.svg";
export { ForwardRef as ReactComponent };